import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-customer-root',
  template: `
    <p-toast />
    <div class="bg-green-100 h-screen">
      <router-outlet />
    </div>
  `,
  imports: [RouterOutlet, ToastModule],
  providers: [MessageService],
  standalone: true
})
export class CustomerAppComponent {} 